module.exports = __webpack_public_path__ + "static/media/2.73b8270e.jpeg";